module.exports = __webpack_public_path__ + "static/media/price_label.309a201b.svg";